const semanticRetroDark = {
    bg: {
        default: '#131619',
        neutral: '#1D1E20',
    },
    fill: {
        default: '#222325',
        neutral: '#939BA4',
        primary: '#599EF2',
        error: '#FF6682',
        warning: '#C28030',
        success: '#48AD67',
        complementary: '#FF5F0F',
        supplementary1: '#A66BD7',
        supplementary2: '#009591',
        contrary: {
            transparent: '#FFFFFF54', // #FFFFFF 33%
            subtler: {
                transparent: '#FFFFFF0A', // #FFFFFF 4%
            },
            subtle: {
                transparent: '#FFFFFF1A', // #FFFFFF 10%
            },
            strong: {
                transparent: '#FFFFFF7A', // #FFFFFF 48%
            },
        },
        blend: {
            transparent: '#0000006B', // #000000 42%
            subtle: {
                transparent: '#0000001F', // #000000 12%
            },
            strong: {
                transparent: '#0000008F', // #000000 56%
            },
        },
        subtler: {
            neutral: '#2A2B2D',
            primary: '#1A2A52',
            error: '#54171A',
            warning: '#4D2D0E',
            success: '#123019',
            complementary: '#59260F',
            supplementary1: '#261735',
            supplementary2: '#002322',
        },
        subtle: {
            neutral: '#313235',
            primary: '#033A7D',
            error: '#7A051B',
            warning: '#603400',
            success: '#0A491D',
            complementary: '#6E2603',
            supplementary1: '#261735',
            supplementary2: '#002322',
        },
        global: {
            primary: '#0D6BDE',
            error: '#DA1639',
            dark: {
                transparent: '#0000006B', // #000000 42%
            },
            light: {
                transparent: '#FFFFFF54', // #FFFFFF 33%
            },
            subtle: {
                dark: {
                    transparent: '#0000001F', // #000000 12%
                },
                light: {
                    transparent: '#FFFFFF1A', // #FFFFFF 10%
                },
            },
            strong: {
                dark: {
                    transparent: '#0000008F', // #000000 56%
                },
                light: {
                    transparent: '#FFFFFF7A', // #FFFFFF 48%
                },
            },
            success: '#247F40',
            supplementary1: '#9053C2',
            supplementary2: '#007C7C',
            supplementary3: '#2974A8',
            neutral: '#555B62',
            complementary: '#9D3B0F',
            warning: '#B36200',
        },
    },
    text: {
        neutral: '#939BA4',
        primary: '#599EF2',
        error: '#FF6682',
        warning: '#C28030',
        success: '#48AD67',
        complementary: '#FF5F0F',
        supplementary1: '#A66BD7',
        supplementary2: '#009591',
        strong: {
            neutral: '#DFE3E8',
            primary: '#A8CCF8',
            error: '#F6AAB8',
            warning: '#E1BD93',
            success: '#9ECEAD',
            complementary: '#FFAB81',
            supplementary1: '#BB8CE0',
            supplementary2: '#00B2AE',
        },
        stronger: {
            neutral: '#F7F9FA',
            primary: '#F2F8FF',
            error: '#FFF2F5',
            warning: '#FFF9F2',
            success: '#F2FFF6',
            complementary: '#FFF7F2',
            supplementary1: '#F7F2FB',
            supplementary2: '#D4FCFB',
        },
        inverse: {
            neutral: '#131619',
            primary: '#001F45',
            error: '#44010D',
            warning: '#361E00',
            success: '#022B0F',
            complementary: '#3D1501',
            supplementary1: '#22132D',
            supplementary2: '#001E1E',
        },
        global: {
            strong: {
                warning: '#E1BD93',
            },
        },
    },
    icon: {
        neutral: '#8E9194',
        primary: '#3B90F7',
        error: '#FF2638',
        warning: '#FFD700',
        success: '#09A639',
        complementary: '#FF5500',
        supplementary1: '#864EB5',
        supplementary2: '#007573',
        inverse: '#131619',
    },
    border: {
        neutral: '#686F79',
        primary: '#0D6BDE',
        error: '#DA1639',
        warning: '#B36200',
        success: '#247F40',
        complementary: '#CF4B0A',
        supplementary1: '#864EB5',
        supplementary2: '#007573',
        subtle: {
            neutral: '#313235',
            primary: '#213C77',
            error: '#771D23',
            warning: '#5D350E',
            success: '#174823',
            complementary: '#6B2C0F',
            supplementary1: '#38214C',
            supplementary2: '#003130',
        },
        strong: {
            neutral: '#C1C6CE',
            primary: '#7AB1F4',
            error: '#F17E93',
            warning: '#D19F61',
            success: '#74B688',
            complementary: '#FF8548',
            supplementary1: '#BB8CE0',
            supplementary2: '#00B2AE',
        },
    },
    state: {
        hover: '#FFFFFF54', // #FFFFFF 33%
        press: '#0000006B', // #000000 42%
        disable: '#596069',
        inactive: '#000000A6', // #000000 65%
        neutral: {
            hover: '#B6BAC0',
            press: '#3E4349',
        },
        subtle: {
            disable: '#313235',
            neutral: {
                hover: '#6E768054', // #6E7680 33%
                press: '#0000006B', // #000000 42%
            },
            primary: {
                hover: '#0E72ED54', // #0E72ED 33%
                press: '#0000006B', // #000000 42%
                disable: '#2B4588',
            },
            error: {
                hover: '#E8173D54', // #E8173D 33%
                press: '#0000006B', // #000000 42%
                disable: '#7A383B',
            },
            warning: {
                hover: '#B3620054', // #B36200 33%
                press: '#0000006B', // #000000 42%
            },
            success: {
                hover: '#26854354', // #268543 33%
                press: '#0000006B', // #000000 42%
            },
            complementary: {
                hover: '#CF4B0A54', // #CF4B0A 33%
                press: '#0000006B', // #000000 42%
            },
            supplementary1: {
                hover: '#9053C254', // #9053C2 33%
                press: '#0000006B', // #000000 42%
            },
            supplementary2: {
                hover: '#007C7C54', // #007C7C 33%
                press: '#0000006B', // #000000 42%
            },
        },
        primary: {
            hover: '#7DB4F7',
            press: '#084085',
        },
        error: {
            hover: '#F38498',
            press: '#830D23',
        },
        warning: {
            hover: '#FFB459',
            press: '#6C3B00',
        },
        success: {
            hover: '#78D995',
            press: '#164C26',
        },
        complementary: {
            hover: '#F89F73',
            press: '#7C2D06',
        },
        supplementary1: {
            hover: '#C8A9E1',
            press: '#572C7B',
        },
        supplementary2: {
            hover: '#3EFFFF',
            press: '#004A4A',
        },
        contrary: {
            subtler: {
                transparent: {
                    hover: '#FFFFFF52', // #FFFFFF 32%
                    press: '#0000007A', // #000000 48%
                },
            },
            subtle: {
                transparent: {
                    hover: '#FFFFFF7A', // #FFFFFF 48%
                    press: '#00000052', // #000000 32%
                },
            },
            transparent: {
                hover: '#FFFFFFA3', // #FFFFFF 64%
                press: '#0000003D', // #000000 24%
            },
            strong: {
                transparent: {
                    hover: '#FFFFFFCC', // #FFFFFF 80%
                    press: '#00000029', // #000000 16%
                },
            },
        },
        global: {
            disable: '#ADB1B8',
            dark: {
                transparent: {
                    hover: '#0000007A', // #000000 48%
                    press: '#000000CC', // #000000 80%
                },
            },
            light: {
                transparent: {
                    hover: '#FFFFFFA3', // #FFFFFF 64%
                    press: '#0000003D', // #000000 24%
                },
            },
            subtle: {
                dark: {
                    transparent: {
                        hover: '#0000003D', // #000000 24%
                        press: '#0000007A', // #000000 48%
                    },
                },
                light: {
                    transparent: {
                        hover: '#FFFFFF7A', // #FFFFFF 48%
                        press: '#00000052', // #000000 32%
                    },
                },
            },
            strong: {
                dark: {
                    transparent: {
                        hover: '#000000A3', // #000000 64%
                        press: '#000000F5', // #000000 96%
                    },
                },
                light: {
                    transparent: {
                        hover: '#FFFFFFCC', // #FFFFFF 80%
                        press: '#00000029', // #000000 16%
                    },
                },
            },
        },
    },
    inverse: {
        default: '#131619',
        neutral: '#1D1E20',
        global: {
            default: '#FFFFFF',
        },
    },
    underlay: {
        dark: '#00000085', // #000000 52%
        default: '#000000CC', // #000000 80%
        dropShadow: '#00000014', // #000000 8%
    },
    component: {
        input: {
            border: '#555B62',
        },
    },
};
export default semanticRetroDark;
